import { render, staticRenderFns } from "./ApiCredentials.vue?vue&type=template&id=bd50dc28&"
import script from "./ApiCredentials.vue?vue&type=script&lang=js&"
export * from "./ApiCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports